import { useNavigate } from "react-router-dom";
import noRowsIcon from "../../../assets/gusers-and-teams-norows-state-icon.svg";
import { layersTwo } from "../../../utility-functions/assetLoader";
import Button from "../Button";

// import gusers-and-teams-norows-state-icon

export default function GTableNoRowsState({ fromScreen }) {
  const navigate = useNavigate();

  const generateMessage = () => {
    let messageComponent = null;

    let mainClassName = "medium-font t6 nc-gray-900";
    let supportingClassName = "regular-font t7 nc-gray-900";
    switch (fromScreen) {
      case "users":
        messageComponent = (
          <>
            <p className={mainClassName}>No users</p>
            <p className={supportingClassName}>No users found.</p>
          </>
        );
        break;
      case "teams":
        messageComponent = (
          <>
            <p className={mainClassName}>No teams</p>
            <p className={supportingClassName}>No teams found.</p>
          </>
        );
        break;
      case "team-view":
        messageComponent = (
          <>
            <p className={mainClassName}>No members</p>
            <p className={supportingClassName}>No members found in team.</p>
          </>
        );
        break;
      case "call-logs":
        messageComponent = (
          <>
            <p className={mainClassName}>No call records</p>
            <p className={supportingClassName}>
              No call records found for selected date range.
            </p>
          </>
        );
        break;
      case "contact-list":
        messageComponent = (
          <>
            <p className={mainClassName}>No campaigns </p>
            <p className={supportingClassName}>No campaigns found.</p>
          </>
        );
        break;
      case "w-templates":
        messageComponent = (
          <>
            <p
              style={{
                fontSize: "18px",
                lineHeight: "28px",
                fontWeight: "500",
                color: "#3F3F46",
                fontFamily: "Inter",
              }}
            >
              No message templates{" "}
            </p>
            <p
              style={{
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: "400",
                color: "#70707B",
                fontFamily: "Inter",
              }}
            >
              Add templates to start messaging.
            </p>
            <Button
              buttonText="Create template"
              hierarchy="green"
              variant="contained"
              buttonStyle={{ marginTop: "32px" }}
              onClick={() => navigate("/w-template/create")}
            />
          </>
        );
        break;
      default:
        messageComponent = (
          <>
            <p className={mainClassName}>No data </p>
            <p className={supportingClassName}>
              No records found for selection.
            </p>
          </>
        );
        break;
    }
    return messageComponent;
  };
  return (
    <div
      style={{
        width: "inherit",
        height: "100%",
        marginTop: "4px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {fromScreen === "w-templates" ? (
        <div
          style={{
            width: "64px",
            height: "64px",
            border: "1.5px solid #F4F4F5",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {layersTwo("#3F3F46", 32, 32)}
        </div>
      ) : (
        <img
          src={noRowsIcon}
          style={{ height: "88px" }}
          alt="No rows vector art"
        />
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "fit-content",
          height: "fit-content",
          alignSelf: "center",
          marginTop: "12px",
          marginBottom: "12px",
          textAlign: "center",
        }}
      >
        {generateMessage()}
      </div>
    </div>
  );
}
